import { memo } from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
} from '@chakra-ui/react'

import { CalendarCheckmark } from 'components/icons'
import { IconButtonWithBadge } from 'components'
import MiniCalendar from 'components/calendar/MiniCalendar'
import DayComponent from './components/DayComponent'

function CalendarButton() {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <IconButtonWithBadge
        onClick={onOpen}
        // onClick={onToggle}
        aria-label="Botão para abrir as suas notificações do sistema"
        variant="ghost"
        colorScheme="gray"
        icon={isOpen ? <CalendarCheckmark /> : <CalendarCheckmark />}
      />

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Minha agenda</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <MiniCalendar DayComponent={DayComponent} />
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Cancelar
            </Button>
            <Button>Ir para a página completa</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default memo(CalendarButton)
